import { createSlice } from '@reduxjs/toolkit';

import fetchTransaction from '../thunks/fetchTransaction';
import processOrder from '../thunks/processOrder';
import processPostCartUpsell from '../thunks/processPostCartUpsell';
import processPaypalOrder from '../thunks/processPaypalOrder';

const initialState = {
  data: {
    success: null,
    response: '',
    response_code: null,
    gateway_response_id: '',
    gateway_response_gateway_id: '',
    gateway_response_code: '',
    gateway_auth_code: '',
    gateway_response_cvv: '',
    gateway_response_avs: '',
    gateway_response_description: '',
    gateway_hard_decline: '',
    date_request: '',
    date_response: '',
    merchant_descriptor: '',
    customer_id: '',
    order_id: '',
    order: {
      id: '',
      customer_id: '',
      campaign_id: '',
      offer_id: '',
    },
    transaction_id: '',
    transaction_total: '',
    shipment_id: '',
  },
  status: '',
  error: null,
};

const transactionSlice = createSlice({
  name: 'transaction',
  initialState,
  reducers: {
    changeTransactionStatus(state, action) {
      state.status = action.payload;
    },
  },
  extraReducers: {
    // view_transaction
    [fetchTransaction.pending]: (state) => {
      state.status = 'loading';
    },
    [fetchTransaction.fulfilled]: (state, action) => {
      state.status = 'succeeded';
      state.data = { ...state.data, ...action.payload };
    },
    [fetchTransaction.rejected]: (state, action) => {
      state.status = 'failed';
      if (action.payload) {
        state.error = action.payload.message;
      } else {
        state.error = action.error.message;
      }
    },
    // process_order
    [processOrder.fulfilled]: (state, action) => {
      state.status = 'succeeded';
      state.data = { ...state.data, ...action.payload.data.transaction };
    },
    [processOrder.rejected]: (state) => {
      state.status = '';
    },
    [processOrder.pending]: (state) => {
      state.status = 'loading';
    },
    // paypal_process_order
    [processPaypalOrder.fulfilled]: (state, action) => {
      state.status = 'succeeded';
      state.data = { ...state.data, ...action.payload.data.transaction };
    },
    [processPaypalOrder.rejected]: (state) => {
      state.status = '';
    },
    [processPaypalOrder.pending]: (state) => {
      state.status = 'loading';
    },
    // Process post cart upsell
    [processPostCartUpsell.fulfilled]: (state, action) => {
      state.status = 'succeeded';
      state.data = { ...state.data, ...action.payload.transaction };
    },
  },
});

export const { changeTransactionStatus } = transactionSlice.actions;

export default transactionSlice.reducer;



// WEBPACK FOOTER //
// ./client/resources/js/checkout/redux/slices/transactionSlice.js